
<template>
  <the-1-column-layout v-if="warrantyRegistration">
    <h2>
      {{loc('warrantyRegistration')}}
      <span style="font-size: 18px; font-weight: 400; color: rgb(130, 130, 130);">
        ({{warrantyRegistration.uuid}})
      </span>
    </h2>

    <h3>{{loc('machineInformation')}}</h3><hr>
    <p>
      <strong>{{loc('serialNumber')}}</strong>: {{warrantyRegistration.serialNumber}}<br />
      <strong>{{loc('machineModel')}}</strong>: {{warrantyRegistration.machine}}<br />
      <strong>{{loc('deliveryDateSold')}}</strong>: {{warrantyRegistration.deliveryDateFormatted}}<br />
    </p>

    <h3>{{loc('customerInformation')}}</h3> <hr>
    <p>
      <strong>{{loc('firstName')}}</strong>: {{warrantyRegistration.customerFirstname}}<br />
      <strong>{{loc('lastName')}}</strong>: {{warrantyRegistration.customerLastname}}<br />
      <span v-if="warrantyRegistration.customerCompany"><strong>{{loc('customerCompany')}}</strong>: {{warrantyRegistration.customerCompany}}<br /></span>
      <strong>{{loc('email')}}</strong>: {{warrantyRegistration.customerEmail}}<br />
      <span v-if="warrantyRegistration.customerPhone"><strong>{{loc('phone')}}</strong>: {{warrantyRegistration.customerPhone}}<br /></span>
      <span v-if="warrantyRegistration.customerAddress"><strong>{{loc('address')}}</strong>: {{warrantyRegistration.customerAddress}}<br /></span>
      <span v-if="warrantyRegistration.customerPostalCode"><strong>{{loc('postalCode')}}</strong>: {{warrantyRegistration.customerPostalCode}}<br /></span>
      <span v-if="warrantyRegistration.customerPostalArea"><strong>{{loc('postalArea')}}</strong>: {{warrantyRegistration.customerPostalArea}}<br /></span>
      <span v-if="warrantyRegistration.customerCountry"><strong>{{loc('country')}}</strong>: {{warrantyRegistration.customerCountry}}<br /></span>
    </p>


    <h3>{{loc('sellerInformation')}}</h3> <hr>
    <p>
      <strong>{{loc('firstName')}}</strong>: {{warrantyRegistration.sellerFirstname}}<br />
      <strong>{{loc('lastName')}}</strong>: {{warrantyRegistration.sellerLastname}}<br />
      <strong>{{loc('email')}}</strong>: {{warrantyRegistration.sellerEmail}}<br />
      <strong>{{loc('store')}}</strong>: {{warrantyRegistration.sellerStore}}<br />
      <span v-if="warrantyRegistration.sellerBusinessId"><strong>{{loc('businessId')}}</strong>: {{warrantyRegistration.sellerBusinessId}}<br /></span>
      <span v-if="warrantyRegistration.sellerStreetAddress"><strong>{{loc('address')}}</strong>: {{warrantyRegistration.sellerStreetAddress}}<br /></span>
      <span v-if="warrantyRegistration.sellerPostalCode"><strong>{{loc('postalCode')}}</strong>: {{warrantyRegistration.sellerPostalCode}}<br /></span>
      <span v-if="warrantyRegistration.sellerPostalArea"><strong>{{loc('postOffice')}}</strong>: {{warrantyRegistration.sellerPostalArea}}<br /></span>
    </p>

    <h3>{{loc('receivedWarrantyDocuments')}}</h3><hr>
    <p>
      <strong>{{loc('components.warrantyRegistrations.warrantyManual')}}</strong>: {{loc('forms.radio.yes')}}<br />
      <strong>{{loc('components.warrantyRegistrations.ceEDeclaration')}}</strong>: {{loc('forms.radio.yes')}}<br />
    </p>

    <hr>
    <p>
      <strong>{{loc('components.warrantyRegistrations.contactAllowed')}}</strong>: {{loc('forms.radio.yes')}}<br />
    </p>
    <p>
      <strong>{{loc('gdprConsent')}}</strong>: {{warrantyRegistration.gdprConsentText}}<br />
    </p>

    <p class="d-print-none"><br /><a href="#" v-on:click="print">{{loc('printDocument')}}</a></p>

  </the-1-column-layout>
</template>

<script>

export default {
  name: 'ViewwarrantyRegistration',
  data: function () {
    return {
      warrantyRegistrationId: null
    }
  },
  computed: {
    warrantyRegistration() {
      let warrantyRegistrationData = this.$store.state.warrantyRegistrations.filter(warrantyRegistration => warrantyRegistration.uuid === this.warrantyRegistrationId)[0];

      if(warrantyRegistrationData){
        warrantyRegistrationData.gdprConsentText = warrantyRegistrationData.gdprConsent == '1' ? this.loc('forms.radio.yes') : this.loc('forms.radio.no');

        if (warrantyRegistrationData.deliveryDate.formatted) {
          const date = new Date(warrantyRegistrationData.deliveryDate.date);

          let year = date.getFullYear();
          let month = date.getMonth() + 1;
          month = month.toString();
          month = month.length == 1 ? '0'+month : month;

          let day = date.getDate();
              day = day.toString();
              day = day.length == 1 ? '0'+day : day;

          warrantyRegistrationData.deliveryDateFormatted = `${year}/${month}/${day}`;
        }
      }

      return warrantyRegistrationData;
    },
  },
  methods: {
    print(e) {
      e.preventDefault();
      window.print();
    }
  },
  mounted() {
    // Check if we have param /company/:id and use that else use logged in user's company as default
    this.warrantyRegistrationId = this.$route.params.id

    this.$store.dispatch('getWarrantyRegistration', this.warrantyRegistrationId);

    this.$store.commit('setSubheader', {
      subtitle: '',
      title: this.loc('components.warrantyRegistrations.subheaderTitle'),
      description: '',
      searchEnabled: true
    });

    let subheader = document.getElementsByClassName('js-subheader');
    if(subheader.length) {
      subheader = subheader[0];
      subheader.classList.add('d-print-none');
    }
  }
}

</script>
